export const capitalize = (text: string) => {
  if (!text) return '';
  return text.charAt(0).toUpperCase() + text.toLowerCase().slice(1);
};
